import { render, staticRenderFns } from "./SettingsSidebar.vue?vue&type=template&id=bb4e189c&scoped=true"
import script from "./SettingsSidebar.vue?vue&type=script&lang=js"
export * from "./SettingsSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4e189c",
  null
  
)

export default component.exports